module.exports = __webpack_public_path__ + "static/media/enterpriseSoftware.503154f9.png";